import { render } from "./UserModules.vue?vue&type=template&id=09aea437"
import script from "./UserModules.vue?vue&type=script&lang=js"
export * from "./UserModules.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__